/* ============================================================
   LG WELCOME BOX
   A new Collagen Greens subscription's first order carries a free Kinto
   bottle and a free Amber Boost as ordinary one-time lines (Tim, 19 Oct
   2026: no kit SKU, so Mauve picks the normal SKUs and renewals stay
   Collagen Greens only — Recharge repeats only the line with a plan).

   The automatic discount "Welcome box: free Kinto bottle + Amber Boost"
   prices them at £0, but like every Buy X get Y it only discounts a Y that
   is already in the basket. This file is what puts them there, and takes
   them out again when the subscription goes, so nobody pays £53 for a
   "gift".

   WHICH LINES ARE OURS
   --------------------------------------------------------
   Gift lines carry a hidden `_welcome_box` property. That is how this tells
   its own lines from an Amber Boost the shopper chose to buy, which it never
   touches. The underscore keeps it out of the drawer, /cart and checkout,
   and a line with properties is a separate line from the same variant
   without them.

   WHEN IT RUNS
   --------------------------------------------------------
   On page load (a basket built by a /cart/add link) and after every
   cartUpdate — the PDP's product-form, the drawer, /cart, the upsell row.
   It talks to /cart/add.js and /cart/update.js only, so it never meets
   lg-plan-guard.js, which owns /cart/change.js. Checkout buttons are held
   while it works, so a fast click cannot leave without the box.

   Links that go straight to /checkout never load this file; they carry the
   gifts in the link itself.
   ============================================================ */
(function () {
  'use strict';

  var el = document.getElementById('lg-welcome-box-config');
  if (!el || !window.routes) return;

  var cfg;
  try {
    cfg = JSON.parse(el.textContent);
  } catch (e) {
    return;
  }
  if (!cfg.enabled || !cfg.trigger || !cfg.gifts || !cfg.gifts.length) return;

  var TAG = '_welcome_box';
  var SOURCE = 'lg-welcome-box';
  var DECLINED = 'lg-welcome-box-declined';
  var running = false;
  var rerun = false;
  var seen = []; /* gift variants present after the last sync */

  /* ------------------------------------------------------------------
     BOTH OR NEITHER. The discount's "gets 2 items" is all-or-nothing:
     with only one gift in the basket it applies to none, and the lone
     "gift" is charged (measured 2 Nov: Amber Boost at £35). So a gift the
     shopper deletes, or one that will not add because it sold out, takes
     the other with it.

     A shopper who deletes a gift has said no. Putting the box back on the
     next cart change would read as the basket fighting them.
     Session-scoped, so a later visit offers it again.
     ------------------------------------------------------------------ */
  function declined() {
    try {
      return sessionStorage.getItem(DECLINED) === '1';
    } catch (e) {
      return false;
    }
  }

  function decline() {
    try {
      sessionStorage.setItem(DECLINED, '1');
    } catch (e) {}
  }

  function giftLines(cart) {
    return cart.items.filter(function (i) {
      return i.properties && i.properties[TAG];
    });
  }

  /* `plans` narrows which plans earn the box; empty means every plan. */
  function hasSubscription(cart) {
    var plans = cfg.plans || [];
    return cart.items.some(function (i) {
      var a = i.selling_plan_allocation;
      return i.product_id === cfg.trigger && a && (!plans.length || plans.indexOf(a.selling_plan.id) !== -1);
    });
  }

  /* What the basket needs, as Cart API payloads. */
  function plan(cart) {
    var lines = giftLines(cart);
    var updates = {};
    var adds = [];

    if (hasSubscription(cart) && !declined()) {
      cfg.gifts.forEach(function (id) {
        var line = lines.filter(function (l) {
          return l.variant_id === id;
        })[0];
        if (!line) {
          adds.push(id);
        } else if (line.quantity !== 1) {
          /* The discount covers one of each; a second would be charged. */
          updates[line.key] = 1;
        }
      });
    } else {
      lines.forEach(function (l) {
        updates[l.key] = 0;
      });
    }

    return { updates: updates, adds: adds };
  }

  /* ------------------------------------------------------------------
     RENDERING — same split as lg-cart-upsell.js. On /cart the page's own
     sections are repainted (a hidden drawer sits in that DOM too). Elsewhere
     the drawer is repainted; renderContents() always opens it, so a closed
     drawer is repainted by hand instead of popping open on page load.
     ------------------------------------------------------------------ */
  function pageTargets() {
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (!items || !footer) return null;
    return [
      { section: items.dataset.id, selector: '.js-contents', root: items },
      { section: footer.dataset.id, selector: '.js-contents', root: footer },
    ];
  }

  function surface() {
    var targets = pageTargets();
    if (targets) {
      return {
        targets: targets,
        ids: targets
          .map(function (t) {
            return t.section;
          })
          .concat('cart-icon-bubble'),
      };
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && drawer.getSectionsToRender) {
      return {
        drawer: drawer,
        ids: drawer.getSectionsToRender().map(function (s) {
          return s.id;
        }),
      };
    }
    return { ids: ['cart-icon-bubble'] };
  }

  function paint(html, selector, target) {
    if (!html || !target) return;
    var source = new DOMParser().parseFromString(html, 'text/html').querySelector(selector || '.shopify-section');
    if (source) target.innerHTML = source.innerHTML;
  }

  function render(json, where) {
    if (!json || !json.sections) return;

    var bubble = document.getElementById('cart-icon-bubble');

    if (where.targets) {
      where.targets.forEach(function (t) {
        paint(json.sections[t.section], t.selector, t.root.querySelector(t.selector));
      });
      paint(json.sections['cart-icon-bubble'], '.shopify-section', bubble);
    } else if (where.drawer) {
      var drawer = where.drawer;
      if (drawer.classList.contains('active')) {
        drawer.renderContents(json);
      } else {
        drawer.getSectionsToRender().forEach(function (s) {
          var target = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
          paint(json.sections[s.id], s.selector, target);
        });
      }
      if (typeof json.item_count === 'number') {
        var empty = json.item_count === 0;
        drawer.classList.toggle('is-empty', empty);
        var inner = drawer.querySelector('.drawer__inner');
        if (inner) inner.classList.toggle('is-empty', empty);
      }
    } else {
      paint(json.sections['cart-icon-bubble'], '.shopify-section', bubble);
    }
  }

  function holdCheckout(on) {
    document.querySelectorAll('[name="checkout"]').forEach(function (b) {
      if (on && !b.disabled) {
        b.disabled = true;
        b.dataset.lgWelcomeHeld = '1';
      } else if (!on && b.dataset.lgWelcomeHeld) {
        b.disabled = false;
        delete b.dataset.lgWelcomeHeld;
      }
    });
  }

  async function post(url, body) {
    var res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    var json = await res.json();
    return res.ok && !json.status ? json : null;
  }

  async function sync() {
    if (running) {
      rerun = true;
      return;
    }
    running = true;
    holdCheckout(true);

    try {
      var res = await fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } });
      var cart = await res.json();
      var todo = plan(cart);

      seen = giftLines(cart).map(function (l) {
        return l.variant_id;
      });
      if (!todo.adds.length && !Object.keys(todo.updates).length) return;

      var where = surface();
      var base = { sections: where.ids, sections_url: window.location.pathname };
      var last = null;

      if (Object.keys(todo.updates).length) {
        last = (await post(window.routes.cart_update_url + '.js', Object.assign({ updates: todo.updates }, base))) || last;
      }

      if (todo.adds.length) {
        var items = todo.adds.map(function (id) {
          var item = { id: id, quantity: 1, properties: {} };
          item.properties[TAG] = cfg.label;
          return item;
        });
        /* One request for both, so a sold-out gift fails the pair (Shopify
           rejects the whole add) — then clear any gift already in the
           basket rather than leave it to be charged. */
        var added = await post(window.routes.cart_add_url + '.js', Object.assign({ items: items }, base));
        if (added) {
          last = added;
          seen = seen.concat(todo.adds);
        } else {
          var now = await (await fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })).json();
          var clear = {};
          giftLines(now).forEach(function (l) {
            clear[l.key] = 0;
          });
          if (Object.keys(clear).length) {
            last = (await post(window.routes.cart_update_url + '.js', Object.assign({ updates: clear }, base))) || last;
          }
          seen = [];
        }
      }

      if (last) {
        render(last, where);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: last });
        }
      }
    } catch (e) {
      /* A failed sync leaves the basket as the shopper built it. The daily
         order check catches a box that did not make it. */
    } finally {
      holdCheckout(false);
      running = false;
      if (rerun) {
        rerun = false;
        sync();
      }
    }
  }

  /* A gift that was in the basket, gone after a drawer or /cart change while
     the subscription is still there, was removed by the shopper. Dawn's
     remove button sends no variant id, so this compares against `seen`. */
  function noteDeclines(cartData) {
    if (!cartData || !cartData.items || !hasSubscription(cartData)) return;
    var now = giftLines(cartData).map(function (l) {
      return l.variant_id;
    });
    var gone = seen.some(function (id) {
      return now.indexOf(id) === -1;
    });
    if (gone) decline();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source === SOURCE) return;
      if (event.source === 'cart-items') noteDeclines(event.cartData);
      sync();
    });
  }

  sync();
})();
